module.exports = __webpack_public_path__ + "ab75e718329c4fa8b2bbafb90d131762.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/blg-logistics.svg
// module id = 939
// module chunks = 0